import React from "react";
import ListElement from "../../navbars/elements/ListElement";
import ListHeader from "../../navbars/elements/ListHeader";
import { faFile } from "@fortawesome/free-solid-svg-icons";

const DocumentsSideNav = () => {
  return (
    <>
      <ListHeader title="Your Documents" />
      <ListElement
        name="Documents"
        targetUrl="/documents"
        icon={faFile}
      />
    </>
  );
};

export default DocumentsSideNav;
